import { AddFacilityAction, AddRoomFacilityAction, AddExtraFacilityAction } from './../../core/store/search/actions';
import { ISearchFacilityGroup, FacilityState } from './../../core/models/search';
import { IFacility } from './../../core/models/facility';
import { SearchService } from './../../core/services/search.service';
import { getFacilities, getRoomFacilities, getExtraFacilities } from './../../core/store/search/selectors';
import { HeaderChangeAction } from './../../core/store/general/actions';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { SharedContainer } from '../../shared/shared.container';

/**
 *
 */
@Injectable()
export class SearchContainer {

  public isLoggedIn$;
  public header$;
  public facilityGroups$: Array<ISearchFacilityGroup>;
  public roomFacilities$: Array<ISearchFacilityGroup>;
  public extras$: Array<ISearchFacilityGroup>;

  constructor(
    protected searchAPI: SearchService,
    protected searchState$: Store<FacilityState>,
    private sharedContainer: SharedContainer
  ) {

    /*this.facilityGroups$ = new Array<ISearchFacilityGroup>();
    searchAPI.getFacilities()
      .subscribe( (facilitiesInfo: Array<any>) => {
        const facilities =  this.populateFacilities(facilitiesInfo, 'facilitiesCollection');
        this.searchState$.dispatch(new AddFacilityAction({ facilities: facilities }));
    });

    this.roomFacilities$ = new Array<ISearchFacilityGroup>();
    searchAPI.getRoomFacilities()
      .subscribe( (facilitiesInfo: Array<any>) => {
        this.searchState$.dispatch(new AddRoomFacilityAction({
          facilities: this.populateFacilities(facilitiesInfo, 'roomPropertyCollection')
        }));
      });*/
    /*this.extras$ = new Array<ISearchFacilityGroup>();
    searchAPI.getOptionalCategories()
      .subscribe( (extraFacilities: Array<any>) => {
        this.createExtrasModel(extraFacilities);
        this.searchState$.dispatch(new AddExtraFacilityAction({
          facilities: this.createExtrasModel(extraFacilities)
      }));
    });*/


    /*this.searchState$.select(getFacilities)
      .subscribe(arg => {
        for (const [key, value] of Object.entries(arg['entities'])) {
          this.facilityGroups$.push(this.populateFacility(value));
        }
      });

    this.searchState$.select(getRoomFacilities)
    .subscribe(arg => {
      for (const [key, value] of Object.entries(arg['entities'])) {
        this.roomFacilities$.push(this.populateFacility(value));
      }
    });*/

    /*this.searchState$.select(getExtraFacilities)
    .subscribe(arg => {
      for (const [key, value] of Object.entries(arg['entities'])) {
        this.extras$.push(this.populateFacilityExtra(value));
      }
    });*/

  }

  populateFacility(value) {
    const facility: ISearchFacilityGroup = {
      id: value['id'],
      name: value['name'],
      facilities: value['facilities']
    };
    return facility;
  }

  populateFacilityExtra(value) {
    const facility: ISearchFacilityGroup = {
      id: value['id'],
      name: value['name'],
      facilities: value['facilities'],
    };
    return facility;
  }

  createExtrasModel(extraFacilities) {
    const facilities: Array<IFacility> = extraFacilities.map(fac => {
      const faci: IFacility = { id: fac.id, title: fac.category, isChecked: false };
      return faci;
    });
    const facilityGroup: ISearchFacilityGroup = {
      id: 1,
      name: 'extras',
      facilities: facilities
    };

    return facilityGroup;
  }

  populateFacilities(facilitiesInfo, collectionTitle) {
    const facilitiesArr: Array<ISearchFacilityGroup> = new Array();
    for (const fetchedFacility of facilitiesInfo) {
      const facilities: Array<IFacility> = fetchedFacility[collectionTitle].map(fac => {
        const faci: IFacility = { id: fac.id, title: fac.name, isChecked: false };
        return faci;
      });
      const facility: ISearchFacilityGroup = {
        id: fetchedFacility['id'],
        name: fetchedFacility['groupName'],
        facilities: facilities
      };
      facilitiesArr.push(facility);
    }

    return facilitiesArr;
  }


  sendRequest(data) {
    return this.searchAPI.sendRequest(data[0]);
  }

  changeHeader() {
    this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, {headerType: 'home'}));
  }
}
